import { render, staticRenderFns } from "./password.vue?vue&type=template&id=fbf88138&"
import script from "./password.vue?vue&type=script&lang=ts&"
export * from "./password.vue?vue&type=script&lang=ts&"
import style0 from "./password.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports